import React from 'react';
import { Activity } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 px-4 bg-[#0f0f0f] relative overflow-hidden" data-id="element-88">
      <div className="absolute right-0 top-1/4 w-1/2 h-1/2 bg-[#C9A84C] opacity-[0.02] blur-[100px] rounded-full pointer-events-none" data-id="element-89"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-90">
        <div className="grid md:grid-cols-[1fr_2px_1fr] gap-8 md:gap-12 items-center" data-id="element-91">
          <div className="text-right hidden md:block" data-id="element-92">
            <Activity className="w-24 h-24 text-[#2a2a2a] ml-auto" data-id="element-93" />
          </div>

          <div className="hidden md:block h-full w-[2px] bg-gradient-to-b from-transparent via-[#C9A84C] to-transparent opacity-30" data-id="element-94"></div>

          <div data-id="element-95">
            <h2 className="text-3xl md:text-4xl font-serif text-white mb-6" data-id="element-96">
              ¿Qué es la glicación?
            </h2>

            <div className="space-y-4 text-[#9a9a9a] text-lg" data-id="element-97">
              <p data-id="element-98">
                La glicación ocurre cuando el azúcar se une a proteínas y grasas
                en tu cuerpo—alterando lentamente su estructura y función con el
                tiempo.
              </p>
              <p className="font-medium text-white" data-id="element-99">
                No es un diagnóstico. Es un proceso biológico real.
              </p>
              <p data-id="element-100">
                Y cuando ocurre en exceso, deja compuestos llamados AGEs
                (Productos Finales de Glicación Avanzada).
              </p>
            </div>

            <div className="mt-8 p-6 bg-[#1a1a1a] border-l-2 border-[#C9A84C] rounded-r-lg" data-id="element-101">
              <p className="text-[#C9A84C] italic font-serif text-xl" data-id="element-102">
                "No duele temprano. No avisa. Por eso es silencioso."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}